import React from "react";
import { Helmet } from "_c/Helmet";

const SearchSeo = ({ noIndex, canonicalUrl, desc, title }) => {
  return (
    <Helmet
      link={[
        canonicalUrl && {
          rel: "canonical",
          href: canonicalUrl,
        },
      ].filter(Boolean)}
      meta={[
        noIndex && {
          name: "robots",
          content: "noindex",
        },
        desc && {
          name: "description",
          content: desc,
        },
      ].filter(Boolean)}
      title={title}
    />
  );
};

export default SearchSeo;
